import { observer } from 'mobx-react-lite';
import React from 'react'
import { useStore } from '../../../../../../../hooks/useStore';

const MapOverviewCityHotpointOverlay = observer(() => {
    const {uiStore: {home__map__showClouds,home__map__activeCity, windowWidth, updateMapCity}, cursorStore: {handleMouseEnter, handleMouseLeave}} = useStore();
    
    if (home__map__activeCity !== "All cities") return null;
    if (home__map__showClouds) return null;

    const width = windowWidth - 120;
    const height = windowWidth * .56247521 ;
    const cities = [
        'Atlanta',
        'Philadelphia',
        'Chicago',
        'Buffalo',
        'LA',
        'Detroit'
    ];

    return (
        <div>
            {cities.map((city) => {
                return (
                    <div 
                        className={`map-overview-city-indicator ${city}`}
                        onClick={() =>{
                            updateMapCity(city)
                            handleMouseLeave()
                        }}
                        onMouseEnter={() => handleMouseEnter("action", `View ${city}`)}
                        onMouseLeave={handleMouseLeave}
                    ></div>
                )
            })}

            <style jsx>{`
                    .map-overview-city-indicator {
                        position: absolute;
                        height: 0;
                        z-index: 1;
                        width: 19%;
                        padding-bottom: 19%;

                        border-radius: 8px;
                        border: 4px solid white;
                        transition: opacity .2s ease;
                        opacity: 0;
                        transform: translate(50vw, 0) translate(-50%, -50%);
                    }
                    
                    .map-overview-city-indicator:hover {
                        opacity: 1;
                    }

                    .map-overview-city-indicator.Atlanta {
                        transform: translate(${width * .2}px,${height * .11}px);
                    }

                    .map-overview-city-indicator.Philadelphia {
                        transform: translate(${width * .4}px,${height * .1}px);
                    }

                    .map-overview-city-indicator.Chicago {

                        transform: translate(${width * .62}px,${height * .15}px);

                    }

                    .map-overview-city-indicator.Buffalo {

                        transform: translate(${width * .18}px,${height * .47}px);
                    }

                    .map-overview-city-indicator.LA {

                        transform: translate(${width * .39}px,${height * .47}px);
                    }

                    .map-overview-city-indicator.Detroit {

                        transform: translate(${width * .605}px,${height * .5}px);
                    }

            `}</style>
        </div>
    )
})

export default MapOverviewCityHotpointOverlay